"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.optimizeSessionTimeout = exports.enabledFeatures = exports.enabledFeature = exports.postOptimizeActivate = exports.OPTIMIZE_SESSION_TIMEOUT = exports.ENABLED_FEATURES = exports.ENABLED_FEATURE = exports.POST_OPTIMIZE_ACTIVATE = exports.OPTIMIZE = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _ajax = require("./ajax");

var _reduxActions = require("redux-actions");

var _constants = require("../constants");

var _URLS;

var OPTIMIZE = 'OPTIMIZE';
exports.OPTIMIZE = OPTIMIZE;
var POST_OPTIMIZE_ACTIVATE = "".concat(OPTIMIZE, "::POST_ACTIVATE");
exports.POST_OPTIMIZE_ACTIVATE = POST_OPTIMIZE_ACTIVATE;
var ENABLED_FEATURE = "".concat(OPTIMIZE, "::ENABLED_FEATURE");
exports.ENABLED_FEATURE = ENABLED_FEATURE;
var ENABLED_FEATURES = "".concat(OPTIMIZE, "::ENABLED_FEATURES");
exports.ENABLED_FEATURES = ENABLED_FEATURES;
var OPTIMIZE_SESSION_TIMEOUT = "".concat(OPTIMIZE, "::OPTIMIZE_SESSION_TIMEOUT");
exports.OPTIMIZE_SESSION_TIMEOUT = OPTIMIZE_SESSION_TIMEOUT;
var URLS = (_URLS = {}, (0, _defineProperty2["default"])(_URLS, _constants.CONTEXTS.EXTERNAL, "/service-optimize/external/api/v1"), (0, _defineProperty2["default"])(_URLS, _constants.CONTEXTS.LOCAL, "/service-optimize/local/api/v1"), (0, _defineProperty2["default"])(_URLS, _constants.CONTEXTS.SECURE, "/service-optimize/secure/api/v1"), _URLS);
/**
 * Activates an experiment by sending an impression and retrieving a variation
 *
 * @param {String} experimentKey - The description of the document
 * @param optimizeUser
 * @param {String} optimizeUser.identityId - Current identity uuid
 * @param {String} optimizeUser.trackerId - Tracker uuid
 * @param {Object} optimizeUser.attributes - Custom user attributes
 * @param {Boolean} ignoreIdentify - Boolean flag to specify a pure cookie-based test
 * @param {string} context - the current api context
 */

var postOptimizeActivate = function postOptimizeActivate(experimentKey, optimizeUser) {
  var ignoreIdentify = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var context = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : _constants.CONTEXTS.EXTERNAL;
  return /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(dispatch) {
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", (0, _ajax.ajaxPost)(POST_OPTIMIZE_ACTIVATE, dispatch, "".concat((0, _ajax.baseUrl)()).concat(URLS[context], "/variation"), {
                experimentKey: experimentKey,
                optimizeUser: optimizeUser,
                ignoreIdentify: ignoreIdentify
              }, null, _ajax.AXIOS_CONFIG));

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};
/**
 * Enables a feature flag for a user and return all the variables associated with the feature.
 * @param {String} featureKey - The feature flag key
 * @param optimizeUser
 * @param {String} optimizeUser.identityId - Current identity uuid
 * @param {String} optimizeUser.trackerId - Tracker uuid
 * @param {Object} optimizeUser.attributes - Custom user attributes
 * @param {string} context - the current api context
 */


exports.postOptimizeActivate = postOptimizeActivate;

var enabledFeature = function enabledFeature(featureKey, optimizeUser) {
  var context = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _constants.CONTEXTS.EXTERNAL;
  return /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(dispatch) {
      return _regenerator["default"].wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", (0, _ajax.ajaxPost)(ENABLED_FEATURE, dispatch, "".concat((0, _ajax.baseUrl)()).concat(URLS[context], "/feature"), {
                featureKey: featureKey,
                optimizeUser: optimizeUser
              }, {
                featureKey: featureKey
              }, _ajax.AXIOS_CONFIG));

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x2) {
      return _ref2.apply(this, arguments);
    };
  }();
};
/**
 * Return all enabled features for user the variables associated with the feature.
 * @param optimizeUser
 * @param {String} optimizeUser.identityId - Current identity uuid
 * @param {String} optimizeUser.trackerId - Tracker uuid
 * @param {Object} optimizeUser.attributes - Custom user attributes
 * @param {string} context - the current api context
 */


exports.enabledFeature = enabledFeature;

var enabledFeatures = function enabledFeatures(optimizeUser) {
  var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _constants.CONTEXTS.EXTERNAL;
  return /*#__PURE__*/function () {
    var _ref3 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(dispatch) {
      return _regenerator["default"].wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              return _context3.abrupt("return", (0, _ajax.ajaxPost)(ENABLED_FEATURES, dispatch, "".concat((0, _ajax.baseUrl)()).concat(URLS[context], "/features"), {
                optimizeUser: optimizeUser
              }, _ajax.AXIOS_CONFIG));

            case 1:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function (_x3) {
      return _ref3.apply(this, arguments);
    };
  }();
};

exports.enabledFeatures = enabledFeatures;
var optimizeSessionTimeout = (0, _reduxActions.createAction)(OPTIMIZE_SESSION_TIMEOUT, function (experimentKey) {
  return experimentKey;
});
exports.optimizeSessionTimeout = optimizeSessionTimeout;